export default "__VITE_ASSET__jlFTWdgg__"